export default "__VITE_ASSET__DgELiR9c__"